import {
  apiRoutes,
  getWardsFn,
  type DefaultQueryError,
  type Ward,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetWards = (
  params: {
    districtId: string;
  },
  opts?: UseQueryOptions<Ward[], DefaultQueryError>
) =>
  useQuery<Ward[], DefaultQueryError>({
    queryKey: [apiRoutes.intercity.wards(params.districtId)],
    queryFn: () => getWardsFn(params.districtId),
    ...opts,
  });
